module.exports = __webpack_public_path__ + "img/img23.d3f31019.svg";